import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FilterWidthState {
  width: "";
}

const initialState: FilterWidthState = {
  width: "",
};

const FilterWidthSlice = createSlice({
  name: "FilterWidth",
  initialState,
  reducers: {
    setFilterWidth: (state: FilterWidthState, action: PayloadAction<any>) => {
      state.width = action.payload;
    },
  },
});

export const { setFilterWidth } = FilterWidthSlice.actions;
export default FilterWidthSlice.reducer;
